import axiosInstance from '../config/axios';
import { toastService } from './toast';

export const bookService = {
    getAll: async () => {
        try {
            const response = await axiosInstance.get('/api/store/books');
            return response.data;
        } catch (error) {
            // Handle book fetch error
            toastService.error('حدث خطأ أثناء جلب الكتب');
            throw error;
        }
    },

    getById: async (id) => {
        try {
            const response = await axiosInstance.get(`/api/store/books/${id}`);
            // Process API response data
            
            // معالجة البيانات قبل إرجاعها
            const bookData = response.data;
            return {
                ...bookData,
                author: bookData.author || 'غير معروف',
                category: bookData.category || 'بدون تصنيف',
                file_size: bookData.file_size || 0
            };
        } catch (error) {
            // Handle book details fetch error
            toastService.error('حدث خطأ أثناء جلب تفاصيل الكتاب');
            throw error;
        }
    }
};
